// === cursor-circle.js ===
(() => {
    const DEBUG_ON =
        (new URLSearchParams(location.search).get("debug") || "")
            .split(",")
            .map((s) => s.trim().toLowerCase())
            .includes("cursor") || window.__cursorDebug === true;

    const log = (...a) => {
        if (DEBUG_ON) console.log("[cursor]", ...a);
    };

    const circleEl = document.querySelector(".circle");
    if (!circleEl) {
        console.warn("[cursor] .circle not found");
        return;
    }

    // внутрішній елемент для rotate/scale
    let inner = circleEl.querySelector(".circle__squeeze");
    if (!inner) {
        inner = document.createElement("span");
        inner.className = "circle__squeeze";
        circleEl.appendChild(inner);
    }

    const mouse = { x: 0, y: 0 },
        prev = { x: 0, y: 0 },
        pos = { x: 0, y: 0 };
    let scale = 0,
        angle = 0;
    const speed = 0.17;
    let visible = false;
    let snapFrames = 0;

    function applyTransform() {
        // внешнее кольцо — только движение
        circleEl.style.transform = `translate3d(${pos.x}px, ${pos.y}px, 0)`;
        // внутреннее — сквиз + вращение
        inner.style.transform = `rotate(${angle}deg) scale(${1 + scale}, ${1 - scale})`;
    }

    function snapToMouse() {
        pos.x = mouse.x;
        pos.y = mouse.y;
        prev.x = mouse.x;
        prev.y = mouse.y;
        scale = 0;
        snapFrames = 1; // сразу 1 кадр без сглаживания
        applyTransform();
    }

    function show(reason) {
        if (visible) return;
        log("SHOW reason:", reason);
        snapToMouse();
        circleEl.style.opacity = "1";
        visible = true;
    }

    function hide(reason) {
        if (!visible) return;
        log("HIDE reason:", reason);
        circleEl.style.opacity = "0";
        visible = false;
    }

    function hasPointerCursor(el) {
        while (el && el !== document.documentElement) {
            if (
                /^(A|BUTTON|LABEL|INPUT|SELECT|TEXTAREA|SUMMARY)$/.test(el.tagName)
            )
                return "pointer";
            const cur = getComputedStyle(el).cursor || "";
            if (cur.indexOf("pointer") >= 0) return "pointer";
            el = el.parentElement;
        }
        return "";
    }

    const isSuppressed = (el) =>
        !!(el && el.closest?.('[data-cursor-suppress="1"]'));

    // fallback для портфолио-зоны
    const portfolioEl = document.querySelector(".inc");
    let inPortfolio = false;
    function toggleBlendFallback(x, y) {
        if (!portfolioEl) return;
        const r = portfolioEl.getBoundingClientRect();
        const inside = x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
        if (inside !== inPortfolio) {
            inPortfolio = inside;
            circleEl.classList.toggle("no-blend", inside);
            log("blend", inside ? "OFF (no-blend on)" : "ON (difference)");
        }
    }

    window.addEventListener(
        "mousemove",
        (e) => {
            mouse.x = e.clientX;
            mouse.y = e.clientY;

            const topEl = document.elementFromPoint(e.clientX, e.clientY);
            const curReason = topEl ? hasPointerCursor(topEl) : "";
            const suppressed = topEl ? isSuppressed(topEl) : false;

            if (suppressed) hide("suppressed");
            else if (curReason === "pointer") hide("computed cursor(pointer)");
            else show("no interactive");

            if (snapFrames > 0) {
                pos.x = mouse.x;
                pos.y = mouse.y;
                prev.x = mouse.x;
                prev.y = mouse.y;
                scale *= 0.5;
                snapFrames--;
                applyTransform();
            } else {
                pos.x += (mouse.x - pos.x) * speed;
                pos.y += (mouse.y - pos.y) * speed;

                const dx = mouse.x - prev.x,
                    dy = mouse.y - prev.y;
                prev.x = mouse.x;
                prev.y = mouse.y;

                const v = Math.min(Math.hypot(dx, dy) * 4, 150);
                const s = (v / 150) * 0.5;
                scale += (s - scale) * speed;
                if (v > 20) angle = (Math.atan2(dy, dx) * 180) / Math.PI;

                applyTransform();
            }

            toggleBlendFallback(mouse.x, mouse.y);
        },
        { passive: true }
    );

    window.addEventListener("pointerdown", () => hide("pointerdown"), {
        passive: true,
    });
    window.addEventListener("pointerup", () => show("pointerup"), {
        passive: true,
    });

    window.addEventListener(
        "scroll",
        () => toggleBlendFallback(mouse.x, mouse.y),
        { passive: true }
    );
    window.addEventListener(
        "resize",
        () => toggleBlendFallback(mouse.x, mouse.y),
        { passive: true }
    );

    window.addEventListener("blur", () => hide("window blur"), { passive: true });
    document.addEventListener(
        "visibilitychange",
        () => {
            if (document.hidden) hide("hidden");
            else show("visible");
        },
        { passive: true }
    );

    circleEl.style.opacity = "0";
    requestAnimationFrame(() => show("init"));
})();
